import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import { router } from './router/routers'
import "./index.css";
import { Provider } from "react-redux";
import { store, persistor } from "./store/index";
import { PersistGate } from "redux-persist/integration/react";
import './locale';
import { prewarmPdfFonts } from "@/utils/pdfFonts";
import { notification } from "antd";

// 全局配置 notification placement 为 top
notification.config({
  placement: 'top',
});

// 空闲时静默预热 PDF 字体缓存，避免首次打印卡顿
prewarmPdfFonts();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      {/* <React.StrictMode> */}
        <RouterProvider router={router} />
      {/* </React.StrictMode> */}
    </PersistGate>
  </Provider>
);

reportWebVitals();
